module.exports = __webpack_public_path__ + "static/media/boat.dc20734d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/boat.svg
// module id = 379
// module chunks = 0